import {
  ROOT_ROUTE_FOR_ROLE,
  RouteNames,
  ROUTES_BLACKLIST_FOR_ROLE,
  ROUTES_WHITELIST_FOR_ROLE,
} from "model/routing";
import { Route, useParams } from "react-router";
import { AllowedParams, areParamsAllowed } from "../allowedParams";
import { IRouteProps, ROUTES } from "./allRoutesList";

function getRootRouteByRole(role) {
  const routeName: RouteNames =
    ROOT_ROUTE_FOR_ROLE[role] || ROOT_ROUTE_FOR_ROLE.DEFAULT;
  return { ...ROUTES[routeName], path: "/", key: routeName };
}
function getRoutesByRole(role) {
  if (!role) {
    return {};
  }

  let allowedRoutes: { [key: string]: IRouteProps } = {};
  const whitelist = ROUTES_WHITELIST_FOR_ROLE[role];
  const blacklist =
    ROUTES_BLACKLIST_FOR_ROLE[role] || ROUTES_BLACKLIST_FOR_ROLE.DEFAULT;
  allowedRoutes = Object.entries(ROUTES)
    .filter(([k, _]) => (whitelist ? whitelist[k] : true))
    .filter(([k, _]) => (blacklist ? !blacklist[k] : true))
    .reduce((obj, [k, v]) => {
      obj[k] = v;
      obj[k].key = k;
      return obj;
    }, {});

  return allowedRoutes;
}

export function toRoutePath({ path, exact = true }: IRouteProps) {
  if (!path) return "*";
  return exact ? path : `${path}/*`;
}

function RouteElement({
  component: Component,
  allowedParams,
}: {
  component: IRouteProps["component"];
  allowedParams?: AllowedParams;
}) {
  const params = useParams();
  const NotFound = ROUTES[RouteNames.notFound].component;

  return areParamsAllowed(params, allowedParams) ? <Component /> : <NotFound />;
}

export function getProtectedRoutesByRole(role) {
  if (!role) {
    return [];
  }

  const rootRoute = getRootRouteByRole(role);
  const allowedRoutes = getRoutesByRole(role);

  return [rootRoute, ...Object.values(allowedRoutes)].map((route) => (
    <Route
      path={toRoutePath(route)}
      key={route.key}
      element={
        <RouteElement
          key={route.key}
          component={route.component}
          allowedParams={route.allowedParams}
        />
      }
    />
  ));
}
